import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

export const uploadImage = async (file: File | Blob, name: string) => {
    const storage = getStorage();
    const storageRef = ref(storage, name);
    const uploadedImage = await uploadBytes(storageRef, file);
    return await getDownloadURL(uploadedImage.ref);
};
